module.exports = __webpack_public_path__ + "img/china.33605abf.jpg";